import { render, staticRenderFns } from "./CompanyStatus.vue?vue&type=template&id=2616d9ef&scoped=true"
import script from "./CompanyStatus.vue?vue&type=script&lang=js"
export * from "./CompanyStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616d9ef",
  null
  
)

export default component.exports